import React, { useState } from "react";
import SelfServiceContentLayout from "../../components/ContentLayout/SelfServiceLayout";
import DashboardActionCards from "../../components/DashboardActionCards/DashboardActionCards";
import { Subtitle, Title } from "../../components/UIKits/Typography/Typography";
import HomeTablesContainer from "../../components/Home/HomeTablesContainer";
import { getSavedState } from "../../services/localStorage";
import { useNavigate} from "react-router-dom";
import ContentLayout from "../../components/ContentLayout/ContentLayout";

const SelfServiceAdminHome = () => {
   
//   const isMobile = useIsMobile();
  const isMobile = false;
const navigate = useNavigate();

  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const handleSettings = () => {
    if (isMobile) {
      setShowSettingsModal(false);
      navigate("/settings");
      return;
    } else {
      setShowSettingsModal(true);
    }
  };
  return (
    <ContentLayout headerName="" iconName="reportIcon">
      <div className="w-full px-6  py-4  flex flex-col gap-4 !overflow-hidden ">
         
        <div className="flex flex-col gap-12">
           
          <DashboardActionCards />
          <HomeTablesContainer />
        </div>

        {/* <ModalContainer
          showTopCancelButton={false}
          showModal={showSettingsModal}
          setShowModal={setShowSettingsModal}
          width={800}
        >
          <Settings />
        </ModalContainer> */}
      </div>
    </ContentLayout>
  );
};

export default SelfServiceAdminHome;
